/**
 * Single source of truth for the selling entity shown to buyers.
 *
 * Everything here is public-facing seller identity. Bank account details are
 * NEVER stored or displayed here — payouts are configured inside Stripe only.
 *
 * Leave a field as an empty string until the real value is confirmed: empty
 * fields are simply not rendered, so the site never shows a placeholder.
 */
export const BUSINESS = {
  /** Legal / registered name of the entity that sells the licence. */
  legalName: "Skaiboss",
  /** Trading name shown in the product UI. */
  tradingName: "Trends.Discovery",
  /** Registered address lines, in postal order. */
  addressLines: ["Albert Schweitzerlaan", "2552 PH The Hague", "The Netherlands"] as string[],

  /** Company register number, e.g. "KVK 12345678". */
  registrationNumber: "",
  /** VAT / tax number, e.g. "NL001234567B01". */
  vatNumber: "",
  /** Billing and support contact. */
  email: "info@skaiboss.com",
  /** Optional phone number shown next to the address. */
  phone: "",
} as const;

/** Address as a single line, or an empty string when not configured yet. */
export const businessAddress = (): string => BUSINESS.addressLines.join(", ");

/** Registration identifiers as one display string, empty when none are set. */
export const businessRegistrationLine = (): string =>
  [BUSINESS.registrationNumber, BUSINESS.vatNumber && `VAT ${BUSINESS.vatNumber}`]
    .filter(Boolean)
    .join(" · ");
